export default "__VITE_ASSET__CJOQycKX__"